import * as crypto from 'crypto-js'

import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Otb/PlanProvider'

export const validateIfShowColumnInTable = (
  headers: ITableHeader[],
  _paramsToSend: IParamsToSend
) => {
  let newHeaders: ITableHeader[] = []
  if (localStorage.getItem('@OtbPlanColumnsTable:')) {
    const dec = crypto.AES.decrypt(
      localStorage.getItem('@OtbPlanColumnsTable:'),
      'CHAVE'
    ).toString(crypto.enc.Utf8)
    newHeaders = JSON.parse(dec.toString() || '')
  } else {
    newHeaders = [...headers]
  }
  const headersFormatted: ITableHeader[] = newHeaders.map(item => {
    return (item = {
      group: item.group,
      columns: item.columns.map(column => {
        if (column.id === 'empresa-periodo-id') {
          return (column = {
            id: column.id,
            name: column.name,
            show: column.show
          })
        }

        return column
      })
    })
  })

  return headersFormatted
}
